import React from 'react'
import IconHeadBrain from '@/components/icons/IconHeadBrain/IconHeadBrain'
import IconCloudRain from '@/components/icons/IconCloudRain/IconCloudRain'
import IconApple from '@/components/IconApple/IconApple'
import IconLightning from '@/components/icons/IconLightning/IconLightning'
import Carousel from '@/components/molecules/Carousel/Carousel'
import IconSpiral from '@/components/icons/IconSpiral/IconSpiral'
import { Department } from '@/domain/department'
export const conditions = [
  {
    title: 'Addiction',
    subtitle: 'Rehab Centers',
    color: 'bg-green-100',
    link: '/united-states/',
    logo: <IconHeadBrain customCss="w-12 h-12 mx-auto text-gray-1100" />
  },
  {
    title: 'Depression',
    subtitle: 'Treatment Providers',
    color: 'bg-primary-100',
    link: '/condition/depression/',
    logo: <IconCloudRain customCss="w-12 h-12 mx-auto text-gray-1100" />
  },
  {
    title: 'Anxiety',
    subtitle: 'Treatment Providers',
    color: 'bg-amber-100',
    link: '/condition/anxiety/',
    logo: <IconSpiral customCss="w-12 h-12 mx-auto text-gray-1100" />
  },
  {
    title: 'Trauma',
    subtitle: 'Treatment Options',
    color: 'bg-secondary-100',
    link: '/condition/trauma/',
    logo: <IconLightning customCss="w-12 h-12 mx-auto text-gray-1100" />
  },
  {
    title: 'Eating Disorders',
    subtitle: 'Treatment Centers',
    color: 'bg-[#E0F2FF]',
    link: '/condition/eating-disorders/',
    logo: <IconApple customCss="w-12 h-12 mx-auto text-gray-1100" />
  }
]

const ConditionsCarousel = ({
  department
}: {
  department?: Department
}): JSX.Element => {
  const title =
    department === Department.Providers
      ? 'Better Referrals, Better Outcomes'
      : 'Find Treatment'

  const subtitle =
    department === Department.Providers
      ? 'Explore 20,000+ trusted treatment providers nationwide'
      : 'Browse over 20,000 Treatment Providers'

  return (
    <Carousel
      title={title}
      subtitle={subtitle}
      items={conditions}
      viewAllLink="/condition/"
      viewAllLabel="All Conditions"
    />
  )
}

export default ConditionsCarousel
